export default "__VITE_ASSET__Gq0i471E__"